module.exports = __webpack_public_path__ + "media/images/edion/zh/discount-00d7160fa3a9d4ffee80e319b0f6422e.png";